module.exports = "<app-navbar class=\"{{responsiveService.mobileDevice ? 'mobile' : ''}}\"></app-navbar>\n\n<router-outlet></router-outlet>\n\n<app-footer class=\"{{responsiveService.mobileDevice ? 'mobile' : ''}}\"></app-footer>\n\n<app-spinner></app-spinner>\n<toaster-container></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main